var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 10c-13.807 0-25 11.193-25 25 0 13.806 11.193 25 25 25a24.896 24.896 0 0015.822-5.644L66.465 70a2.5 2.5 0 003.537-3.537L54.357 50.82A24.896 24.896 0 0060 35c0-13.806-11.193-25-25-25zm0 5c11.03 0 20 8.97 20 20s-8.97 20-20 20-20-8.97-20-20 8.97-20 20-20zm9.371 13.69a2.176 2.176 0 000-3.056 2.13 2.13 0 00-3.03 0l-6.24 6.325-6.443-6.325a2.129 2.129 0 00-3.03 0c-.84.845-.767 2.283 0 3.056l6.442 6.325-6.443 6.295a2.176 2.176 0 000 3.056c.837.844 2.264.774 3.03 0l6.443-6.294 6.24 6.294a2.129 2.129 0 003.031 0 2.172 2.172 0 000-3.056l-6.24-6.295 6.24-6.325z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotFound);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconNotFound.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };